import { aboutButtons, aboutMariaText } from "i18n/about";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeUp, slideLeft } from "../../animations/variants";

const MainAbout = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = aboutMariaText[lang];
  const btn = aboutButtons[lang];

  const navigate = useNavigate();

  return (
    <section className="bg-[#f5f5f3] py-32 md:py-24">
      <div className="max-w-6xl mx-auto text-[#111] px-6">
        {/* Title */}
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-[Crimson] uppercase tracking-wide text-reddark font-semibold">
            {t.title}
          </h2>
        </div>
        <div className="w-24 h-[2px] bg-reddark mx-auto mt-8 mb-8" />

        {/* Intro */}
        <div className="space-y-8 text-base md:text-lg leading-relaxed">
          {t.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>

      {/* Highlight */}

      <div className="max-w-6xl mx-auto text-[#111] px-6">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="mt-14 border-l-4 border-reddark pl-6 italic text-gray-700 text-lg leading-8"
        >
          {t.highlight}
        </motion.div>
      </div>
      {/* Body */}
      {/* <div className="max-w-4xl mx-auto text-[#111] px-6">
        <div className="space-y-8 text-base md:text-lg leading-relaxed">
          {t.body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div> */}
    </section>
  );
};

export default MainAbout;
